import URLS from '../config/urls';
import BaseAPI from './BaseApi';


class AddressService {
    async deleteAddress(uuid: string): Promise<any> {
        try {
            const response = await BaseAPI.delete(`${URLS.ADDRESSES}/${uuid}`);
            return response; // Retorna a resposta da API
        } catch (e) {
            return { error: "Erro ao deletar" }; // Retorna um objeto de erro
        }
    }

    async createAddress(data: any, uuid: string | undefined): Promise<any> {
        try {
            const response = await BaseAPI.post(`${URLS.ADDRESSES}/${uuid}`, data);
            return response; // Retorna a resposta da API
        } catch (e) {
            return { error: "Erro ao Cadastrar" }; // Retorna um objeto de erro
        }
    }
}

const addressService = new AddressService();
export default addressService;